export default __webpack_public_path__ + "static/media/gp-icon.d6cebd10.svg";